import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CStampProcedure } from '@models/imported/SagaSchema/CStampProcedure';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CacheService } from '@services/cache/cache.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ResourceCountService } from '../../services/resource-count/resource-count.service';

@Component({
  selector: 'app-resource-count-card',
  templateUrl: './resource-count-card.component.html',
  styleUrls: ['./resource-count-card.component.scss']
})
export class ResourceCountCardComponent implements OnInit, OnDestroy {
  @Input()
  callcard: CallCard;

  resourceCount: number;

  private cacheSub: Subscription = null;

  constructor(private resourceCountService: ResourceCountService, private cacheService: CacheService) {}

  ngOnInit() {
    this.refreshResourceCount();

    this.cacheSub = this.cacheService
      .listenForChange(CStampProcedure)
      .pipe(filter(cacheEvent => (cacheEvent.object as CStampProcedure).CallCardId === this.callcard.ObjGuid))
      .subscribe(() => this.refreshResourceCount());
  }

  private refreshResourceCount() {
    this.resourceCount = this.resourceCountService.getResourceCount(this.callcard);
  }

  ngOnDestroy() {
    this.cacheSub.unsubscribe();
  }
}
